import {Box, FormHelperText, OutlinedInput} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import {useState} from "react";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import PropTypes from "prop-types";
import {Visibility, VisibilityOff} from "@material-ui/icons";
import FormControl from "@material-ui/core/FormControl";

const CreazionePasswordStep = (props) => {
    const [passwordError, setPasswordError] = useState({
        first: false,
        confirm: false,
    })
    const [show, setShow] = useState({
        password: false,
        confirmPassword: false,
    })

    const handleClickShowPassword = (type) => {
        setShow((oldShow) => ({...oldShow, [type]: !oldShow[type]}));
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const handleOnBlurPassword = (e) => {
        if (e.target.name === "first") {
            setPasswordError((oldPasswordError) => ({...oldPasswordError, first: !props.isPasswordValidFormat}))
        } else {
            setPasswordError((oldPasswordError) => ({
                ...oldPasswordError,
                confirm: props.passwords.first !== e.target.value
            }))
        }
    }

    return (
        <Box>
            {props.newText ? <Typography variant="body2">{props.newText}</Typography> : <Typography variant="body2">
                La creazione di una password serve ad evitare l’utilizzo improprio del QR code e il furto di dati
                sensibili dalle tue eSIM.</Typography>} <br/>
            <Typography variant="body2">
                <b>ATTENZIONE:</b> Ricordati la password in modo di <b>comunicarla all’utente finale</b> per
                visualizzare il QR code, rispettando le policy di sicurezza.
            </Typography>
            <Grid container spacing={3} alignItems="flex-end" style={{marginTop: "1em"}}>
                <Grid item xs={12} md={6}>
                    <Typography variant="subtitle2">
                        Crea una password per scaricare il QRcode
                    </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                    <FormControl variant="outlined" fullWidth>
                        <OutlinedInput
                            type={show.password ? 'text' : 'password'}
                            value={props.passwords.first}
                            onChange={props.handlePasswordChange}
                            name="first"
                            placeholder="Password*"
                            required
                            fullWidth
                            onBlur={handleOnBlurPassword}
                            style={{backgroundColor: passwordError.first ? "#ffe5e5" : "white"}}
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={() => handleClickShowPassword("password")}
                                        onMouseDown={handleMouseDownPassword}
                                        edge="end"
                                    >
                                        {show.password ? <Visibility/> : <VisibilityOff/>}
                                    </IconButton>
                                </InputAdornment>
                            }
                        />
                        {!!passwordError.first && (
                            <FormHelperText error>
                                La password non rispetta il formato richiesto
                            </FormHelperText>
                        )}
                    </FormControl>
                </Grid>
                <Grid item container xs={12} justifyContent={"flex-end"}>
                    <Grid item md={6} style={{paddingLeft:"1em"}}>
                        <Typography variant="body2">
                            *La password deve contentere:<br></br><br></br>
                            - Almeno un carattere maiuscolo;<br></br>
                            - Almeno un carattere minuscolo;<br></br>
                            - Almeno un numero;<br></br>
                            - Almeno un carattere speciale tra: ! ? # * % & $<br></br>
                            - La password deve contenere almeno 8 caratteri
                            alfanumerici ma non più di 30<br></br>
                        </Typography>
                    </Grid>
                </Grid>
                <Grid item xs={12} md={6}>
                    <Typography variant="subtitle2">
                        Reinserisci la password
                    </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                    <FormControl variant="outlined" fullWidth>
                        <OutlinedInput
                            type={show.confirmPassword ? 'text' : 'password'}
                            value={props.passwords.confirm}
                            onChange={props.handlePasswordChange}
                            name="confirm"
                            placeholder="Password*"
                            required
                            fullWidth
                            onBlur={handleOnBlurPassword}
                            style={{backgroundColor: passwordError.confirm ? "#ffe5e5" : "white"}}
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={() => handleClickShowPassword("confirmPassword")}
                                        onMouseDown={handleMouseDownPassword}
                                        edge="end"
                                    >
                                        {show.confirmPassword ? <Visibility/> : <VisibilityOff/>}
                                    </IconButton>
                                </InputAdornment>
                            }
                        />
                        {!!passwordError.confirm && (
                            <FormHelperText error>
                                Le password non corrispondono
                            </FormHelperText>
                        )}
                    </FormControl>
                </Grid>
            </Grid>
        </Box>
    )
}

CreazionePasswordStep.propTypes = {
    passwords: PropTypes.shape({
        first: PropTypes.string.isRequired,
        confirm: PropTypes.string.isRequired
    }).isRequired,
    handlePasswordChange: PropTypes.func.isRequired,
    isPasswordValidFormat: PropTypes.bool.isRequired
}

export default CreazionePasswordStep